// extracted by mini-css-extract-plugin
export var boxItems = "_9x-1";
export var boxItemsLg = "_9x-2";
export var button = "_9x-7";
export var buttonLg = "_9x-8";
export var filterGroupBox = "_9x-0";
export var icon = "_9x-3";
export var iconSecondary = "_9x-6";
export var iconWrapper = "_9x-4";
export var iconWrapperLg = "_9x-5";